module.exports = __webpack_public_path__ + "img/unterschrift-SG.f3710469.png";